import React from "react";
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import Dropzone from "react-dropzone";
import CloseIcon from "@mui/icons-material/Close";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { budgetFilesProps } from "@/js/common/types/types";

interface Props {
  atrzSttsCd: string;
  fileSeCd: string;
  savedBudgetFiles: budgetFilesProps[];
  setSavedBudgetFiles: React.Dispatch<React.SetStateAction<budgetFilesProps[]>>;
  budgetFiles: File[];
  setBudgetFiles: React.Dispatch<React.SetStateAction<File[]>>;

  width?: number | string;
  height?: number | string;
  itemHeight?: number;
}

const BudgetFile = ({atrzSttsCd, fileSeCd, savedBudgetFiles, setSavedBudgetFiles, budgetFiles, setBudgetFiles, width = 320, height = 140, itemHeight = 30,}: Props) => {
  const boxStyle: React.CSSProperties = {
    width: typeof width === "number" ? `${width}px` : width,
  };

  const dropAreaStyle: React.CSSProperties = {
    borderRadius: 20,
    borderColor: "#999",
    height: typeof height === "number" ? height : height,
    overflowY: "auto",
  };

  return (
    <>
      {savedBudgetFiles.length > 0 && (
        <div className="dpFlx flxdCol">
          <div className="h30 dpFlx aiE pb5">
            <span className="fm-b fs13 ls06 fc111111">첨부파일 조회</span>
          </div>

          <div className="bd1 bdcDDDDDD" style={boxStyle}>
            <div className="w100p dpFlx flxdCol pl10 pr10 pb5 bdBox">
              {savedBudgetFiles.map((item: any, idx: number) => (
                <div
                  key={idx}
                  className="w100p dpFlx aiC jcSb"
                  style={{ height: itemHeight }}
                >
                  <div
                    className="dpFlx aiC csP tdU-hover fc5C93FF-hover"
                    onClick={() => {
                      Axios.dataAccess({
                        url: "system/com/file/download-budget-file.do",
                        methodType: "get",
                        responseType: "blob",
                        paramData: {
                          docId: item.docId,
                          fileSn: item.fileSn,
                          fileSeCd: item.fileSeCd ?? fileSeCd,
                        },
                      });
                    }}
                  >
                    <AttachFileIcon style={{ fontSize: 18, color: "#1E466A" }} />
                    <span className="SpoqaHanSansNeo-Medium fs14 ls075 fc008418">
                      {item.fileNm}
                    </span>
                  </div>

                  {atrzSttsCd !== "03" && atrzSttsCd !== "04" && (
                    <div
                      className="p5 csP dpInBlock mr10 ml20"
                      onClick={(e) => {
                        e.stopPropagation();
                        AppContext.openAlert({
                          title: "첨부파일 삭제",
                          msg: "첨부파일을 삭제하시겠습니까?",
                          icon: "check",
                          confirmText: "파일삭제",
                          handleConfirm: () => {
                            AppContext.showSpinner();
                            Axios.dataAccess({
                              url: "system/com/file/delete-budget-file.do",
                              methodType: "post",
                              paramType: "json",
                              paramData: {
                                docId: item.docId,
                                fileSn: item.fileSn,
                                fileSeCd: item.fileSeCd ?? fileSeCd,
                              },
                              onSuccessFn: () => {
                                const tempFiles: budgetFilesProps[] = [];
                                for (let i = 0; i < savedBudgetFiles.length; i++) {
                                  if (i !== idx) tempFiles.push(savedBudgetFiles[i]);
                                }
                                setSavedBudgetFiles(tempFiles);
                                AppContext.openAlert({
                                  title: "첨부파일 삭제완료",
                                  msg: "첨부파일이 삭제되었습니다.",
                                  icon: "check",
                                });
                                AppContext.hideSpinner();
                              },
                            });
                          },
                        });
                      }}
                    >
                      <div className="dpFlx aiC jcSb">
                        <CloseIcon
                          style={{ fontSize: 22, color: "crimson", paddingRight: "5px" }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      <div className="dpFlx flxdCol">
        <div className="h30 dpFlx aiE pb5">
          <span className="fm-b fs13 ls06 fc111111">첨부파일 저장</span>
        </div>

        <div className="bd1 bdcDDDDDD" style={boxStyle}>
          <Dropzone
            onDrop={(acceptFiles: File[]) => {
              if (acceptFiles.length > 10) {
                AppContext.openAlert({
                  title: "파일 갯수 제한",
                  msg: "파일은 10개를 초과할 수 없습니다.",
                  icon: "check",
                });
                return;
              }

              const nextFiles = [...budgetFiles];

              for (const acceptFile of acceptFiles) {
                const dot = acceptFile.name.lastIndexOf(".");
                const extNm = (dot >= 0 ? acceptFile.name.substring(dot + 1) : "").toLowerCase();

                if (AppContext.fileWhiteExt.indexOf(extNm) === -1) {
                  AppContext.openAlert({
                    title: "파일 확장자 체크",
                    msg: `${extNm} 확장자는 업로드 불가한 확장자의 파일입니다.`,
                    icon: "error",
                  });
                  return;
                }

                nextFiles.push(acceptFile);
              }

              setBudgetFiles(nextFiles);
            }}
          >
            {({ getRootProps, getInputProps }) => (
              <div style={dropAreaStyle} className="csP bdBox" {...getRootProps()}>
                <input {...getInputProps()} />

                {budgetFiles.length === 0 && (
                  <div className="dpFlx aiC jcC bdBox" style={{ height }}>
                    <span className="fm-Pretendard-Medium fs15 fc666666 ls08 pt10">
                      첨부파일을 끌어다 놓으세요.
                    </span>
                  </div>
                )}

                {budgetFiles.map((item: any, idx: number) => (
                  <div
                    key={idx}
                    style={{ borderRadius: 8 }}
                    className="bd1 bdcCECECE p5 csP dpInBlock ml10 mr10 mt10"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="dpFlx aiC jcSb">
                      <span className="fm-Pretendard-Medium fs14 fc2C2C2C ls075 taU fw500">
                        {item.name}
                      </span>
                      <CloseIcon
                        style={{ fontSize: 20, color: "black", paddingLeft: 5 }}
                        onClick={(e) => {
                          e.stopPropagation();
                          const tempFiles: File[] = [];
                          for (let i = 0; i < budgetFiles.length; i++) {
                            if (i !== idx) tempFiles.push(budgetFiles[i]);
                          }
                          setBudgetFiles(tempFiles);
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </Dropzone>
        </div>
      </div>
    </>
  );
};

export default BudgetFile;
